import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "auth-sdk";
import type { WayflyerSchemas } from "api-types";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { addError } from "@wayflyer/blackbox-fe";

const isProduction = import.meta.env.PROD && !window.origin.includes("dev");

export const useIntercomLoaded = () => {
  const enableNewOnboarding = useFeatureFlagEnabled("onboarding-improvements");
  const { data: isIntercomLoaded } = useQuery({
    queryKey: ["intercom-chat-widget"],
    queryFn: async () => {
      try {
        const { data: intercomData } = await axiosClient.get<WayflyerSchemas.IntercomConfigSchema>(
          "/api/wayflyer/intercom/config"
        );
        const Intercom = await import("@intercom/messenger-js-sdk");
        Intercom.default({
          app_id: intercomData.app_id,
          api_base: intercomData.api_base,
          region: "eu",
          intercom_user_jwt: intercomData.jwt_token,
          company_id: intercomData.company_id,
          hide_default_launcher: enableNewOnboarding,
        });
        return true;
      } catch (error) {
        addError("Failed to initialize Intercom", error);
        return false;
      }
    },
    enabled: isProduction || enableNewOnboarding,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return isIntercomLoaded;
};
